import { initialState, TPersonData } from './initialState';

export enum EContactDetailTypes {
    FILL_FIO = '@contact-detail/FILL_FIO',
    FILL_PHONE = '@contact-detail/FILL_PHONE',
    SET_CONFIRMED_PHONE = '@contact-detail/SET_CONFIRMED_PHONE',
    RESET_DATA = '@contact-detail/RESET_DATA',
}

export type TResetDataAction = {
    type: typeof EContactDetailTypes.RESET_DATA,
}

export type TFillFioAction = {
    type: EContactDetailTypes.FILL_FIO,
    payload: Pick<TPersonData, 'editedFio'>,
}

export type TFillPhoneAction = {
    type: EContactDetailTypes.FILL_PHONE,
    payload: Pick<TPersonData, 'editedPhone'>,
}

export type TConfirmPhone = {
    type: EContactDetailTypes.SET_CONFIRMED_PHONE,
    payload: Pick<TPersonData, 'confirmedPhone'>,
}

export type ContactDetailsActions = TFillFioAction |
    TFillPhoneAction |
    TConfirmPhone;

// eslint-disable-next-line default-param-last
export const contactDetails = (state: TPersonData = initialState, action: ContactDetailsActions): TPersonData => {
    switch (action.type) {
        case EContactDetailTypes.FILL_FIO:
        case EContactDetailTypes.FILL_PHONE:
        case EContactDetailTypes.SET_CONFIRMED_PHONE: {
            return {
                ...state,
                ...action.payload,
            };
        }
        default: {
            const unknownAction: never = action;
            return state || unknownAction;
        }
    }
};
